import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Inntopia**
 *
 * @exports bs_348
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let camelBackRefreshPage;
    /**
       * @memberOf module:bs_348
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('.results-title.txt-red-orange');
        if (container && !camelBackRefreshPage) {
            const isLoadingHidden = () => !container.querySelector('span');
            camelBackRefreshPage = thn.debounce(function () {
                if (isLoadingHidden()) {
                    thn.widgets.price.refresh();
                }
            }, 800);
            thn.observeDom(container, camelBackRefreshPage, {
                childList: true,
                subTree: false,
                attributes: false,
            });
            thn.pageUnload(() => {
                camelBackRefreshPage.cancel();
                thn.stopObserveDom(container, camelBackRefreshPage);
                camelBackRefreshPage = null;
            });
        }
    };
    /**
       * @memberOf module:bs_348
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const noAvailability = document.querySelector('#noMatches') || document.querySelector('#lodge_listing h3')?.textContent.match('Hello!');
        // Dates
        const dateBegin = window.thisArrivalDate || document.querySelector('#arrivalDate_1')?.value || thn.parseUrlParameter('ar') || thn.parseUrlParameter('arrivaldate');
        const dateEnd = thn.parseUrlParameter('dp') || thn.parseUrlParameter('departuredate');
        // In camelback Resort, selectors change
        const camelbackResort = thn.data.propertyId === 1034073;
        const datesCamelback = document.querySelector('.date-display')?.textContent?.split(' - ');
        const dateBeginCamelback = datesCamelback?.length ? translateDate(datesCamelback[0], thn.data.language) : '';
        const dateEndCamelback = datesCamelback?.length > 0 ? translateDate(datesCamelback[1], thn.data.language) : '';
        let nights;
        if ((dateBegin && dateEnd) || (dateBeginCamelback && dateEndCamelback)) {
            widgetData.dateBegin = dateBeginCamelback || dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
            widgetData.dateEnd = dateEndCamelback || dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Guests, Adults & Children
        // For camelback Resort, selector is different
        if (camelbackResort) {
            widgetData.adults = thn.parseNumber(document.querySelector('.stepper input')?.value);
            widgetData.children = 0;
            widgetData.guests = widgetData.adults + widgetData.children;
        }
        else {
            const adults = thn.parseNumber((document.querySelector('#adultCountDisplay')?.textContent || window.adultCount)) || 2;
            const children = thn.parseNumber((document.querySelector('#childCountDisplay')?.textContent || window.childCount)) || 0;
            const cheaperRoomInfo = {
                adults: adults,
                children: children,
                childrenAges: [],
            };
            for (let i = 1; i <= cheaperRoomInfo.children; i += 1) {
                // Populate children ages, with 10 for each child as a random number
                cheaperRoomInfo.childrenAges.push(10);
            }
            widgetData.roomsDispo = [cheaperRoomInfo];
        }
        // Prices & Currency || No Rooms
        widgetData.currency = window.currencyCode || thn.parseCurrency((document.querySelector('.h3.base', '[id*="bookNow"]'))?.textContent);
        // If we haven't obtained prices from the datalayer, we obtain them through the DOM elements.
        const prices = [...document.querySelectorAll('.h3.base, [id*="bookNow"]')].filter((el) => thn.isVisible(el)).map((el) => thn.parseNumber((el || {}).textContent) || '');
        prices.sort((a, b) => a - b);
        if (!thn.empty(prices) && widgetData.currency && nights) {
            widgetData.price = prices[0];
            widgetData.set = true;
        }
        else if (noAvailability) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_348
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const dataLayer = window.innDataLayer;
        const bookingId = thn.objectGet(dataLayer, 'transactionId');
        const bookingInfo = thn.objectGet(dataLayer, 'transactionProducts')?.length && thn.objectGet(dataLayer, 'transactionProducts')[0];
        // At Camelback resort, you can make reservations for attractions and stays.
        // We want to exclude bookings that do not contain dates (those that do not belong to stays).
        const isCamelbackResort = thn.data.propertyId === 1034073;
        if (!bookingInfo || (isCamelbackResort && !bookingInfo.arrivalDate && !bookingInfo.departureDate)) {
            widgetData.set = false;
            return widgetData;
        }
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        widgetData.bookingId = bookingId;
        widgetData.dateBegin = thn.dateToString(bookingInfo.arrivalDate);
        widgetData.dateEnd = thn.dateToString(bookingInfo.departureDate);
        widgetData.children = thn.parseNumber(bookingInfo.childCount);
        widgetData.adults = thn.parseNumber(bookingInfo.adultCount);
        widgetData.price = parseFloat(thn.objectGet(dataLayer, 'transactionTotal'));
        widgetData.currency = thn.parseCurrency(window.currency) || window.currencyCode;
        return widgetData;
    };
    /**
     * @memberOf module:bs_348
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
    engine.getPromocode = function getPromocode(ctx) {
        const promoMessage = !!document.querySelector('h3.mb-3') && document.querySelector('.lodge-promo > div > input[type=text]')?.value;
        const promoParam = thn.parseUrlParameter('promo');
        const promocode = promoMessage || promoParam;
        if (promocode) {
            ctx.promocode = promocode;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
